import { CardItemModel } from "../card/card-item-model";
import { CheckBoxItemModel } from "../checkbox/checkbox-item-model";

export interface AccordionItemModel {
	title: string;
	text?: string;
    cards?: CardItemModel[];
    checks?: CheckBoxItemModel[];
	expanded?: boolean;
	firstExpanded?: boolean;
}